import React, { useEffect, useState, useRef,useContext } from 'react';
// import { BotonNuevo } from "../components/buttons/BotonNuevo";
// import { BotonProcesar } from "../components/buttons/BotonProcesar";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';
import { Modal } from '../../components/modal/Modal';
import { EstrellaCalificacion } from '../../components/EstrellasCalificacion';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { useCalificaciones } from '../../../hooks/useCalificaciones';
import { useModal } from '../../../hooks/useModal';
import { primeraLetraMayuscula } from '../../../utils/utils';

export const CalificacionesConductor =()=>{
    // const classNameInput = "text-white h-[30px] rounded px-4 w-full bg-zianc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    const {spinner,listarCalificacionPromedio, calificacionesPromedio,calificacionesDetalleConductor,listarCalificacionesDetalleConductor} = useCalificaciones()
    const [isOpenModalCalificacion, openModalCalificacion, closeModalCalificacion] = useModal()
    const [conductorElegido, setConductorElegido ] = useState({})
    
    useEffect(() => {
        listarCalificacionPromedio()
    }, []);
    const abrirModalCalificacion = () => {
        openModalCalificacion()
    }
return(
    <>
        <ContenedorParametros titulo="Calificación de Conductores">
            <BotonProcesar onClick={()=>listarCalificacionPromedio() }></BotonProcesar>
        </ContenedorParametros>

        <ContenedorTabla>
            <div className='containerScroll   mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                <table className="table ">
                    <thead>
                        <tr>
                            <th className="w-[30px]">N</th>
                            <th className="text-left">CONDUCTOR</th>
                            <th>CALIFICACIÓN PROMEDIO</th>
                            <th className="w-[10px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                        calificacionesPromedio?.length > 0 
                        ? calificacionesPromedio?.map((calificacionPromedio, i) => {
                            return (
                                <tr key={calificacionPromedio?.codPersonaConductor}>
                                    <td>{ i + 1}</td>
                                    <td className='text-left'>{ primeraLetraMayuscula(calificacionPromedio?.nombrePersonaConductor)}</td>
                                    <td className="text-center">
                                        <EstrellaCalificacion 
                                            tamaño='xl' 
                                            cantidadEstrellas= {calificacionPromedio?.promedioEstrellas} 
                                        >
                                        </EstrellaCalificacion>
                                    </td>
                                    <td className="text-center w-[10px]" >
                                        <button 
                                            onClick={()=> {listarCalificacionesDetalleConductor(calificacionPromedio?.codPersonaConductor, calificacionPromedio?.codEmpresa);abrirModalCalificacion();setConductorElegido({conductor: calificacionPromedio?.nombrePersonaConductor,cantidadEstrellasPromedio:calificacionPromedio?.promedioEstrellas})}} 
                                            className="bg-blue-500 hover:bg-blue-600 text-[14px] px-[5px] py-1 rounded"
                                        >
                                            <i className="fas fa-list"></i>
                                        </button>
                                    </td>    
                                </tr>
                            )
                        })
                        : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                    }
                    </tbody>
                </table>
            </div>
        </ContenedorTabla>

        <Modal
            isOpen={isOpenModalCalificacion} closeModal={closeModalCalificacion} action={{}}
            title="Calificación de Conductor"
            spinner={spinner}
            textButtons={{ confirm: '', denied: 'Cerrar' }}
            validButton={{confirm: false, denied: true}}
        >
            <div className="flex items-center  flex-wrap justify-center">
                <div className="w-full text-xl ">
                    <div className='text-xl mb-3'>
                        <i className='text-xl fa fa-user pr-3' aria-hidden="true"></i>
                        {primeraLetraMayuscula(conductorElegido?.conductor)}
                    </div>
                    <div>Calificación promedio: <EstrellaCalificacion tamaño='' cantidadEstrellas={conductorElegido?.cantidadEstrellasPromedio}></EstrellaCalificacion></div>
                    <ContenedorTabla>
                        <div>Detalle de Calificaciones</div>
                        <div className='containerScroll  max-h-[300px] relative top-0 bottom-0 left-0 right-0 contenedor-tabla'>
                            <table className="table text-xl">
                                <thead>
                                    <tr>
                                        <th className="w-[30px]">N</th>
                                        <th className="text-center">FECHA</th>
                                        <th>COMENTARIO</th>
                                        <th className="w-[10px]">ESTRELLAS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {   
                                        calificacionesDetalleConductor?.length > 0 
                                        ? calificacionesDetalleConductor.map((detalle, i) => {
                                            return (
                                                <tr key={detalle?.codConductor}>
                                                    <td>{ i + 1}</td>
                                                    <td className='text-center'>{ detalle?.fechaCalificacion}</td>
                                                    <td className='text-center'>{ detalle?.comentarioCalificacion}</td>
                                                    <td className="text-center"><EstrellaCalificacion cantidadEstrellas= {detalle?.cantidadEstrellas} ></EstrellaCalificacion></td>
                                                </tr>
                                            )
                                        })
                                        : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </ContenedorTabla>
                </div>
            </div>
        </Modal>

    </>
)
}